import styled from '@mui/system/styled';

export const ContentCnt = styled('div')({
  padding: '0',
  '& ul': {
    paddingLeft: '24px',
    marginTop: '8px',
  },
});
